document.addEventListener('DOMContentLoaded' , () =>{
	if(document.querySelector('.main-page')){
        //today
        let tSlider = $('.js-t-slide'),
            tSliderOptions = {
                infinite: true,
                arrows: true,
                dots: false,
                slidesToScroll:1,
            };

        $(window).on('load resize', function(){
            if($(window).width() < 767) {
                if(tSlider.hasClass('slick-slider')){
                    tSlider.slick('unslick');
                }
            }else{
                tSlider.not('.slick-initialized').slick(tSliderOptions);
            }
        });

        //learning__list
        $(".js-learning-slide").slick({
            infinite: true,
            arrows: true,
            dots: false,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToScroll:1,
            variableWidth: true,
            centerMode: true,
        });
	}
});
